import { Outlet, Route, Routes } from "react-router-dom";
import EditAboutYou from "../../../components/common/edit-form/about-you/EditAboutYou";
import EditExpenses from "../../../components/common/edit-form/expenses/EditExpenses";
import EditIncome from "../../../components/common/edit-form/income/EditIncome";
import { routePaths } from "../../../routing/routePaths";

const EditForm = () => {
  return (
    <>
      <Routes>
        <Route path={routePaths.editProfile} element={<EditAboutYou />} />
        <Route path={routePaths.editIncome} element={<EditIncome />} />
        <Route path={routePaths.editExpenses} element={<EditExpenses />} />
      </Routes>
      <Outlet />
    </>
  );
};

export default EditForm;
